import React, { Component } from "react";
import api from "../../config/api";
import { connect } from "react-redux";
import {
  damSelectedComp,
  damSelectedIDsComp,
  openSnackComp,
  damComp,
  damTotalRegistrosComp,
  damTotalPaginasComp,
  damNumeroPaginaComp,
  damTamanhoPaginaComp,
} from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Box, Menu, MenuItem } from "@material-ui/core";
import { Fab, Tooltip } from "@material-ui/core";
import Footer from "../../components/Footer";
import MenuDebitsManager from "../../components/MenuDebitsManager";
import FilterDAMManager from "../../components/FilterDAMManager";
import TableDAMs from "../../components/TableDAMs";
import LoadingDefault from "../../components/LoadingDefault";
import ContentNotLoaded from "../../components/ContentNotLoaded";
import { arrayRemoveItem } from "../../helper/arrayRemoveItem";
import { errorDefault } from "../../helper/errorDefault";
import { convertDebitsData } from "../../helper/convertDebitsData";
import { convertBrazilianDateToISO } from "../../helper/convertDate";
import Messages from "../../helper/resources/Messages";
import Constants from "../../helper/resources/Constants";
import MenuDebitsAttendant from "../../components/MenuDebitsAttendant";
import { Print } from "@material-ui/icons/";
import { b64toBlob } from "../../helper/convertBase64toBlob";
import validationPermission from "../../helper/validationPermission";
import PrintVariacaoMensalRel from "../../components/PrintVariacaoMensalRel";

const styles = () => ({
  container: {
    padding: "0px 30px 20px 30px",
    marginTop: "130px",
  },
  menuGroup: {
    display: "flex",
    width: "100%",
    marginTop: "10px",
    marginBottom: "30px",
    padding: "20px 0px 0px 0px",
  },
  menuIcon: {
    width: 30,
    marginRight: 7,
  },
  linkGroup: {
    textDecoration: "none",
  },
  button: {
    color: "rgb(24, 116, 185)",
    fontSize: 17,
    background: "none",
    border: "none",
    boxShadow: "none",
  },
  loadingDiv: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  loadingDivRel: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "12px",
  },
  marginBottom: {
    marginBottom: 40,
  },
  inputsItem: {
    display: "flex",
  },
  cardContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 40,
  },
  pagination: {
    //width: '55%',
    border: "none",
    margin: "0 auto",
  },
  IconeFabFilter: {
    backgroundColor: "#fff",
    color: "#0066b2",
    transition: "all .2s",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  IconeFabRelatorio: {
    backgroundColor: "#fff",
    marginRight: "10px",
    color: "#0066b2",
    transition: "all .2s",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  ajustePrinter: {
    marginTop: "5px",
  },
});

export class FindDAMManager extends Component {
  constructor(props) {
    super(props);
    this.getDAM = this.getDAM.bind(this);
    this.handleSimpleRel = this.handleSimpleRel.bind(this);
    this.handleDetailRel = this.handleDetailRel.bind(this);

    this.state = {
      dams: [],
      damSelected: [],
      isHovering: true,
      loadingDAM: false,
      errorMessage: "",
      errorLoadDam: false,
      isNewPageInstance: true,
      rowsPerPage: 36,
      page: 0,
      activeFilters: {},
      anchorEl: null,
      open: false,
      id: undefined,
      errorReport: false,
      loadingRel: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    this.props.openSnackComp(false);
    this.props.damComp([]);
    this.props.damSelectedComp([]);
    this.props.damSelectedIDsComp([]);
    //this.getDAM()
  }

  getFormattedDate(date) {
    return date !== null && date !== undefined
      ? convertBrazilianDateToISO(date)
      : "";
  }

  fetchDAMs(filterParams) {
    let params = {
      page: filterParams.page,
      itemsByPage: filterParams.itemsByPage,
      tipoInscricao: filterParams.tipoDocumentoContribuinte,
      inscricao: filterParams.numeroContribuinte,
      tributo: filterParams.codigoTributo,
      valorMinimo: filterParams.valorMinimo,
      valorMaximo: filterParams.valorMaximo,
      dataVencimentoMinima: this.getFormattedDate(filterParams.dataInicio),
      dataVencimentoMaxima: this.getFormattedDate(filterParams.dataFim),
      dataEmissaoMinima: this.getFormattedDate(filterParams.dataEmissaoInicio),
      dataEmissaoMaxima: this.getFormattedDate(filterParams.dataEmissaoFim),
      campoOrdenacao: filterParams.campoOrdenacao,
      sentidoOrdenacao: filterParams.sentidoOrdenacao,
    };

    return api.get("Gestao/Dam", { params });
  }

  async getDAM(filterParams) {
    this.setState(
      {
        loadingDAM: true,
        errorMessage: "",
        errorLoadDam: false,
        snackBarMessage: "",
        isNewPageInstance: false,
        damSelected: [],
        activeFilters: filterParams,
      },
      () => {
        this.props.openSnackComp(false);
        this.props.damComp([]);
        this.props.damSelectedComp([]);
        this.props.damSelectedIDsComp([]);
      }
    );

    try {
      const damGroup = await this.fetchDAMs(filterParams);
      let damList = [];
      if (damGroup.data.List !== null && damGroup.data.List !== undefined) {
        if (damGroup.data.List.length > 0) {
          const map = new Map();
          for (const item of damGroup.data.List) {
            if (!map.has(item.IdDam)) {
              map.set(item.IdDam, true);
              damList.push(item);
            }
          }
        }

        this.setState({
          dams: damList,
        });

        damList.forEach((item) => {
          convertDebitsData(item);
        });

        this.setState(
          {
            dams: damList,
            loadingDAM: false,
            errorLoadDam: false,
          },
          () => {
            this.props.damComp(damList);
            this.props.damTotalRegistrosComp(damGroup.data.TotalRecords);
            this.props.damTotalPaginasComp(damGroup.data.TotalPages);
            this.props.damNumeroPaginaComp(damGroup.data.NumberPage);
            this.props.damTamanhoPaginaComp(damGroup.data.SizePage);
          }
        );
      } else {
        this.setState({
          dams: [],
          loadingDAM: false,
          errorMessage: Messages.NENHUM_FILTRO_PREENCHIDO,
          errorLoadDam: true,
        });
        this.props.damComp([]);
      }
    } catch (error) {
      let errorMessage = errorDefault(error);

      this.setState({
        errorMessage: errorMessage,
        errorLoadDam: true,
        loadingDAM: false,
      });
    }
  }

  handleSortDAMs = (sortDirection, orderBy) => {
    this.getDAM({
      ...this.state.activeFilters,
      campoOrdenacao: orderBy,
      sentidoOrdenacao: sortDirection,
    });
  };

  handleSearchDebts = (filterParams, validation) => {
    if (validation.isValid) {
      this.getDAM(filterParams);
    } else {
      if (validation.errorMessage !== "") {
        this.setState(
          {
            snackBarMessage: validation.errorMessage,
          },
          () => {
            this.props.openSnackComp(true);
          }
        );
      }
    }
  };

  handleGetCardSelected = (id, checked) => {
    if (checked) {
      this.setState(
        (prevState) => ({
          damSelected: [...prevState.damSelected, id],
          isHovering: !this.state.isHovering,
        }),
        () => {
          this.props.damSelectedIDsComp(this.state.damSelected);
        }
      );
    } else {
      let updatedSelectedItems = this.state.damSelected;
      updatedSelectedItems = arrayRemoveItem(updatedSelectedItems, id);

      this.setState(
        {
          damSelected: updatedSelectedItems,
        },
        () => {
          this.props.damSelectedIDsComp(updatedSelectedItems);
        }
      );
    }
  };

  handleChangePage = (event, newPage) => {
    const previousFilters = this.state.activeFilters;
    this.setState({ activeFilters: { ...previousFilters, page: newPage } });
    this.getDAM({ ...previousFilters, page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    const previousFilters = this.state.activeFilters;
    const itemsByPage = event.target.value;
    this.setState({
      activeFilters: { ...previousFilters, page: 1, itemsByPage },
    });
    this.getDAM({ ...previousFilters, page: 1, itemsByPage });
  };

  consultarDam = (dam) => {
    this.props.history.push({
      pathname: "/consultar-dam",
      aboutProps: {
        DAMValue: dam.NumeroDam,
        contribuinte: "",
        returnUrl: "/dam",
      },
    });
  };

  handleClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
      open: Boolean(event.currentTarget),
      id: "simple-popover",
    });
  }

  handleClose(event) {
    this.setState({
      anchorEl: event.currentTarget,
      open: false,
      id: undefined,
    });
  }

  handleSimpleRel() {
    const { activeFilters } = this.state;
    this.setState(
      {
        loadingRel: true,
      },
      () => this.handleClose({ currentTarget: false })
    );

    let params = {
      page: activeFilters.page,
      itemsByPage: activeFilters.itemsByPage,
      tipoInscricao: activeFilters.tipoDocumentoContribuinte,
      inscricao: activeFilters.numeroContribuinte,
      tributo: activeFilters.codigoTributo,
      valorMinimo: activeFilters.valorMinimo,
      valorMaximo: activeFilters.valorMaximo,
      dataVencimentoMinima: this.getFormattedDate(activeFilters.dataInicio),
      dataVencimentoMaxima: this.getFormattedDate(activeFilters.dataFim),
      dataEmissaoMinima: this.getFormattedDate(activeFilters.dataEmissaoInicio),
      dataEmissaoMaxima: this.getFormattedDate(activeFilters.dataEmissaoFim),
      campoOrdenacao: activeFilters.campoOrdenacao,
      sentidoOrdenacao: activeFilters.sentidoOrdenacao,
    };
    try {
      api
        .get("Gestao/RelatorioSimplificadoDams", { params })
        .then((DAMResponse) => {
          let pdf = "";

          if (DAMResponse.data !== null && DAMResponse.data !== undefined) {
            pdf = DAMResponse.data;

            this.setState({
              loadingRel: false,
              errorReport: false,
            });

            var file = b64toBlob(pdf, "application/pdf");
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          } else {
            this.setState({
              loadingRel: false,
              errorReport: true,
            });
          }
        });
    } catch (error) {
      this.setState({
        loadingRel: false,
        errorReport: true,
      });
    }
  }

  handleDetailRel() {
    const { activeFilters } = this.state;
    this.setState(
      {
        loadingRel: true,
      },
      () => this.handleClose({ currentTarget: false })
    );

    let params = {
      page: activeFilters.page,
      itemsByPage: activeFilters.itemsByPage,
      tipoInscricao: activeFilters.tipoDocumentoContribuinte,
      inscricao: activeFilters.numeroContribuinte,
      tributo: activeFilters.codigoTributo,
      valorMinimo: activeFilters.valorMinimo,
      valorMaximo: activeFilters.valorMaximo,
      dataVencimentoMinima: this.getFormattedDate(activeFilters.dataInicio),
      dataVencimentoMaxima: this.getFormattedDate(activeFilters.dataFim),
      dataEmissaoMinima: this.getFormattedDate(activeFilters.dataEmissaoInicio),
      dataEmissaoMaxima: this.getFormattedDate(activeFilters.dataEmissaoFim),
      campoOrdenacao: activeFilters.campoOrdenacao,
      sentidoOrdenacao: activeFilters.sentidoOrdenacao,
    };
    try {
      api
        .get("Gestao/RelatorioDetalhadoDams", { params })
        .then((DAMResponse) => {
          let pdf = "";

          if (DAMResponse.data !== null && DAMResponse.data !== undefined) {
            pdf = DAMResponse.data;

            this.setState({
              loadingRel: false,
              errorReport: false,
            });

            var file = b64toBlob(pdf, "application/pdf");
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          } else {
            this.setState({
              loadingRel: false,
              errorReport: true,
            });
          }
        });
    } catch (error) {
      this.setState({
        loadingRel: false,
        errorReport: true,
      });
    }
  }

  render() {
    const { classes, user } = this.props;
    const {
      isNewPageInstance,
      loadingDAM,
      errorLoadDam,
      errorMessage,
      open,
      errorReport,
      loadingRel,
    } = this.state;

    const { profile } = user;

    return (
      <div>
        <Grid container className={classes.container}>
          {profile === Constants.PERFIL_ATENDENTE ? (
            <MenuDebitsAttendant />
          ) : (
            <MenuDebitsManager />
          )}

          <Box width={1}>
            <FilterDAMManager
              loadingDAM={loadingDAM}
              GetDebtsManager={this.handleSearchDebts}
              HasRequiredFields={false}
            />
          </Box>
          {loadingDAM && (
            <div className={classes.loadingDiv}>
              <LoadingDefault typeLoading={"card"} />
            </div>
          )}

          {!isNewPageInstance &&
            this.props.damValue.length === 0 &&
            !loadingDAM &&
            !errorLoadDam && (
              <ContentNotLoaded
                message={"Nenhum DAM foi encontrado no sistema."}
              />
            )}

          {errorLoadDam && <ContentNotLoaded message={errorMessage} />}
          {errorReport && (
            <div className={classes.loadingDiv}>
              <ContentNotLoaded
                message={"Erro na geração do relatório do DAM."}
              />
            </div>
          )}

          <div className={classes.cardContainer}>
            <br />
            <Grid
              flex
              spacing={3}
              container
              justifyContent="flex-end"
              className={classes.ajustePrinter}
            >
              <Grid item>
                {validationPermission(user, "UC012") && (
                  <PrintVariacaoMensalRel />
                )}
                {this.props.damValue.length > 0 && (
                  <>
                    <Fab
                      className={classes.IconeFabFilter}
                      onClick={this.handleClick}
                    >
                      <Tooltip placement="top" title="Relátorios">
                        {loadingRel ? (
                          <div className={classes.loadingDivRel}>
                            <LoadingDefault typeLoading={"debits"} />
                          </div>
                        ) : (
                          <Print />
                        )}
                      </Tooltip>
                    </Fab>
                    <Menu
                      id="basic-menu"
                      open={open}
                      anchorEl={this.state.anchorEl}
                      onClose={this.handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem onClick={this.handleSimpleRel}>
                        Relatório Resumido
                      </MenuItem>
                      <MenuItem onClick={this.handleDetailRel}>
                        Relatório Detalhado
                      </MenuItem>
                    </Menu>
                  </>
                )}
              </Grid>
            </Grid>

            {this.props.damValue.length > 0 && (
              <TableDAMs
                page={this.props.damNumeroPaginaValue}
                rowsPerPage={this.props.damTamanhoPaginaValue}
                handleChangePage={this.handleChangePage}
                handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                order={this.state.activeFilters?.sentidoOrdenacao}
                orderBy={this.state.activeFilters?.campoOrdenacao}
                getSortedDAMs={this.handleSortDAMs}
                totalRecords={this.props.damTotalRegistrosValue}
                totalPages={this.props.damTotalPaginasValue}
                damsList={this.props.damValue}
                consultarDam={this.consultarDam}
              />
            )}
          </div>
        </Grid>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  damValue: store.cardDebitState.damValue,
  damSelectedValue: store.cardDebitState.damSelectedValue,
  damSelectedIDsValue: store.cardDebitState.damSelectedIDsValue,
  openSnackValue: store.cardDebitState.openSnackValue,
  damTotalRegistrosValue: store.cardDebitState.damTotalRegistrosValue,
  damTotalPaginasValue: store.cardDebitState.damTotalPaginasValue,
  damNumeroPaginaValue: store.cardDebitState.damNumeroPaginaValue,
  damTamanhoPaginaValue: store.cardDebitState.damTamanhoPaginaValue,
  user: store.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      damComp,
      damSelectedComp,
      damSelectedIDsComp,
      openSnackComp,
      damTotalRegistrosComp,
      damTotalPaginasComp,
      damNumeroPaginaComp,
      damTamanhoPaginaComp,
    },
    dispatch
  );

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(FindDAMManager)
);
